import { render, staticRenderFns } from "./interestComponent.vue?vue&type=template&id=21bd778d&"
import script from "./interestComponent.vue?vue&type=script&lang=js&"
export * from "./interestComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports